<!-- 关联用户 -->
<template>
  <div class="dialogBox">
    <el-transfer
      filterable
      :props="{ key: 'userId', label: 'name' }"
      filter-placeholder="用户"
      :titles="['未选用户', '已选用户']"
      v-model="selectUser"
      :data="allUser"
    >
    </el-transfer>
    <el-row type="flex" v-if="rowInfo.actionable" class="dailogButBox" justify="center">
      <el-col :span="7">
        <el-button size="medium" @click="$emit('reload')">取消</el-button>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" type="primary" @click="submit">确认</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["rowInfo"],
  data() {
    return {
      selectUser: [],
      allUser: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.$axios.get("/user/role/" + this.rowInfo.id).then((res) => {
        let data = res.data.data;
        let list = [];
        data.filter((item) => {
          list.push(item.userId);
        });
        this.selectUser = list;
      });
      this.$axios.get("/user/select").then((res) => {
        this.allUser = res.data.data;
      });
    },
    submit() {
      this.$axios({
        method: "put",
        url: "/role/relevance/" + this.rowInfo.id,
        data: this.selectUser,
      }).then((res) => {
        this.$message({ type: "success", message: '保存成功!' ,duration:1000});
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogBox {
  padding: 10px;
}
</style>
